import React from 'react';
import { withPrefix } from 'gatsby';

const Image = ({ filename, alternativeText, className, ...rest }) => (
  <img src={withPrefix(filename)} alt={alternativeText} className={className} {...rest} />
);

export default Image;
